// extracted by mini-css-extract-plugin
module.exports = {"sidebarReportItem":"styles_sidebarReportItem__1IKWU","active":"styles_active__1C2UV"};